import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import clientsAction from '@state/client/actions';
import devicesApi from '@api/devicesApi';

function useClientesEditCreate() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [form] = Form.useForm();

  const dataInit = useSelector(({ clients: c }) => c.createEditClient);
  const idToEdit = useSelector(({ clients: c }) => c.clientIdToEdit);

  const currentUserRol = useSelector(({ user }) => user.role);
  const [dataForm, setDataForm] = useState(dataInit);
  const [loadingForm, setLoadingForm] = useState(false);

  const [businessData, setBusinessData] = useState([]);
  const [typeCommunity, setTypeCommunity] = useState([]);
  const [devicesData, setDevicesData] = useState([]);

  const abortC = new AbortController();
  const { signal } = abortC;

  const defaultData = { // data by defaul in redux
    celsia_id: '',
    third_id: '',
    description: '',
    stratum: 1,
    business_type_id: '',
    representative: false,
    devices_id: '',
  };

  const readDevices = (businessTypes) => {

    const skip = 0;
    const limit = 1000;

    devicesApi.getAllDeviceByBusiness2(signal, skip, limit, businessTypes)
      .then(async (devices) => {

        const newDevices = await Promise.all(devices.map(async (obj) => {

          const item = {
            value: obj.id,
            label: obj.name,
          };

          return item;

}));

        setDevicesData(newDevices);

      }).catch((resError) => {

        if (signal.aborted) return;
        const { fem } = resError;
        console.log('fem ', fem);

});

  };

  // eslint-disable-next-line
  const createClient = () => {   

    let body;

    if (typeCommunity === 'AmiIoT') {

       body = { ...dataInit, devices_id: [dataInit.devices_id] };

} else {

       body = { ...dataInit, devices_id: [] };

}

    setLoadingForm(true);
    devicesApi.createClient({ signal, body })
    .then(async (response) => {

      setLoadingForm(false);

      message.success(t('forms.clients.feedbacks.client_success'));
      setDataForm(defaultData);
      dispatch(clientsAction.setCreateEditClient(defaultData));
      dispatch(clientsAction.setClientIdEdit(null));

      history.push('/clientes');

    })
    .catch((resError) => {

        message.error(t('forms.clients.feedbacks.client_failed'));
        setLoadingForm(false);

});

  };

  // eslint-disable-next-line
  const editClient = () => {  

    let body;

    if (typeCommunity === 'AmiIoT') {

      body = { ...dataInit, devices_id: [dataInit.devices_id] };

} else {

        body = { ...dataInit, devices_id: [] };

}

    setLoadingForm(true);
    devicesApi.updateClient({ signal, id: idToEdit, body })
    .then(async (response) => {

      setLoadingForm(false);

      message.success(t('forms.clients.feedbacks.update_success'));
      setDataForm(defaultData);
      dispatch(clientsAction.setCreateEditClient(defaultData));
      dispatch(clientsAction.setClientIdEdit(null));

      history.push('/clientes');

    })
    .catch((resError) => {

        message.error(t('forms.clients.feedbacks.update_failed'));
        setLoadingForm(false);

});

  return false;

  };

  const onFinish = useCallback((values) => {

    if (idToEdit) {

      editClient();

    } else {

      createClient();

    }
    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => {

    // eslint-disable-next-line
    console.log(errorInfo);
    message.error(t('tables.logs.rows.error'));

  };

  const formOnValuesChange = useCallback( // handle data of api
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);

      if (key[0] === 'representative') {

        return false;

}

      setDataForm({ ...dataForm, [key[0]]: data[0] });
      dispatch(clientsAction.setCreateEditClient({ ...dataForm, [key[0]]: data[0] }));

      return true;

},
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const onChangeRepresentative = (value) => {

    setDataForm({ ...dataForm, representative: value });
    dispatch(clientsAction.setCreateEditClient({ ...dataForm, representative: value }));

};

  const onDataChange = (value) => { // data imcomplete

    // eslint-disable-next-line
    let businessTypeIdsQuery = ''; 
    const objbusinessType = businessData.find((objeto) => objeto.value === value);

    setTypeCommunity(objbusinessType?.type_community);

    setDataForm({ ...dataForm, business_type_id: value, devices_id: [] });

    // eslint-disable-next-line
    dispatch(clientsAction.setCreateEditClient({ ...dataForm, business_type_id: value, devices_id: [] }));

    // Actualiza los valores de los campos del formulario
    form.setFieldsValue({ ...dataForm, business_type_id: value, devices_id: [] });

    if (value !== '') {

      businessTypeIdsQuery += `business_type_id=${value}`;

}

    readDevices(businessTypeIdsQuery);

};

  const cancelCreateEditUser = useCallback( // cancel: edit user, create user
    () => {

      history.push('/clientes');

},
    // eslint-disable-next-line
    [],
  );

  const readBusinessType = useCallback(async () => {

    const skip = 0;
    const limit = 1000;

    const queryParams = '&type=Comunidades';

    await devicesApi.getAllBusinessTypeQuery({
 signal, skip, limit, queryParams,
})
      .then(async (business) => {

          const newBusiness = await Promise.all(business.map(async (obj) => {

            const item = {
              value: obj.id,
              label: obj.name,
              devices: obj.total_general,
              clients: obj.total_general_clients,
              type: obj.type,
              type_community: obj?.ext_community?.type,
            };
            return item;

}));

          setBusinessData(newBusiness);

      }).catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          console.log('fem ', fem);

      });

  });

  useEffect(() => { // mount component

    if (businessData.length > 0) {

       // eslint-disable-next-line
      const objbusinessType = businessData.find((objeto) => objeto.value === dataInit.business_type_id);
      setTypeCommunity(objbusinessType?.type_community);

}

}, [businessData]);

  useEffect(() => { // mount component

    readBusinessType();

    if (idToEdit) {

      let businessTypeIdsQuery = '';
      if (dataInit.business_type_id !== '') {

        businessTypeIdsQuery += `business_type_id=${dataInit.business_type_id}`;

}
      readDevices(businessTypeIdsQuery);

}

    if (!idToEdit && location.pathname === '/clientes/editar-cliente') {

      // If trying to edit without idToEdit, redirect to tipo-negocio
        history.push('/clientes');

    } else if (!idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin') {

      // If trying to create without idToEdit and not Superadmin or Admin, redirect to tipo-negocio
          history.push('/clientes');

}
    return function cleanUp() {

      dispatch(clientsAction.setCreateEditClient(defaultData));
      dispatch(clientsAction.setClientIdEdit(null));

    };
  // eslint-disable-next-line
  }, []);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditUser,
    businessData,
    onChangeRepresentative,
    loadingForm,
    onDataChange,
    devicesData,
    typeCommunity,
    form,
  };

}

export default useClientesEditCreate;
